import { createContext, useContext, useEffect, useState } from "react";
import { CustomerStatus } from "./../api/index";
import { getLocalCart } from "./../config/commonfunctions/AddToCart";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [cartCount, setCartCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const checkAuth = async () => {
    try {
      const res = await CustomerStatus();
      setUser(res.data.data);
    } catch (error) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const refreshCartCount = async () => {
    try {
      const res = await getLocalCart();
      setCartCount(res.cart.items.length);
    } catch (error) {
      setCartCount(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkAuth();
    refreshCartCount();
  }, []);

  return (
    <AuthContext.Provider
      value={{ user, loading, setUser, cartCount, refreshCartCount }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
